import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Loader2 } from "lucide-react";

interface InstructionsFieldProps {
  instructions: string;
  onInstructionsChange: (value: string) => void;
  onEnhanceInstructions: () => Promise<void>;
  isEnhancing: boolean;
  name: string;
}

export const InstructionsField = ({
  instructions,
  onInstructionsChange,
  onEnhanceInstructions,
  isEnhancing,
  name
}: InstructionsFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="instructions">System Instructions</Label>
      <div className="space-y-2">
        <Textarea
          id="instructions"
          value={instructions}
          onChange={(e) => onInstructionsChange(e.target.value)}
          placeholder="Enter the instructions for your assistant..."
          className="h-32"
          required
        />
        <Button 
          type="button" 
          variant="secondary" 
          onClick={onEnhanceInstructions}
          disabled={isEnhancing || !name || !instructions}
          className="w-full"
        >
          {isEnhancing ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Enhancing Instructions...
            </>
          ) : (
            'Enhance Instructions'
          )}
        </Button>
      </div>
    </div>
  );
};